/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import NumberFormat from 'react-number-format';
import { Accordion } from 'react-accessible-accordion';
import { bindActionCreators as bind } from 'redux';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import CTA from '../shared/CTA';
import { Retirement } from '../../data/ducks';
import Title from '../shared/Title';
import StartPlanResultCTA from '../shared/StartPlanResultCTA';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { mp, getCampaign, withCommas } from '../../constants/utils';
import { palette, breakpoints, flexCenter, flexRow, flexColumn } from '../../constants/styles';
import { HEADER_HEIGHT, FlowHeader } from '../GoalsFlow/styles';
import {
  WhiteLogo,
  StyledBlueSpan,
  StyledGreenSpan,
  StyledAchieveRetirementSection,
} from '../shared/resultsStyles';
import OptionCard from '../shared/OptionCard';
import Icon from '../shared/Icon';
import Text from '../shared/Text';
import GetStarted from '../landing/GetStarted';
import {
  retirementVehicles,
  resultTypes,
  PENSION_PLAN_PRICE,
  DISCOUNTED_PENSION_PLAN_PRICE,
} from '../../constants/constants';
import SimpleQA from '../shared/SimpleQA';
import PlusMinus from '../shared/PlusMinus';
import CTAButton from '../shared/CTAButton';
import Bullets from '../shared/Bullets';
import GetStartedWithExample from '../shared/GetStartedWithExample';
import FollowingCTA from '../shared/FollowingCTA';
import CallUs from '../shared/CallUs';
import { mq } from '../../styles/theme';
import NavBar from '../shared/Navbar';
import FAQuestion from '../landing/FAQuestion';
import Swal from 'sweetalert2';
import { finautaTwilioClient } from '../../config/axios';
import Button from '../shared/Button';
import { Mixpanel } from '../mixpanel';
var Scroll = require('react-scroll');
var scroll = Scroll.animateScroll;

const REPLACE_IDENTIFIER = 'XX';

const FACTOR_DE_INTEGRACION = 1.06512;

const StyledExampleOverlay = styled.div`
  height: 115vh;
  width: 200vw;
  margin-left: 20px;
  position: absolute;
  color: rgba(0, 0, 0, 0.2);
`;

const StyledOnlyTextSection = styled.div`
  ${flexColumn}
  ${flexCenter}
  max-width: 400px;
`;

const StyledCTASection = styled.div`
  ${flexColumn}
  ${flexCenter}
  max-width: 400px;
  margin-bottom: 30px;
`;

const StyledFeaturesSection = styled.div`
  ${flexColumn}
  ${flexCenter}
  max-width: 400px;
  margin-bottom: 30px;
`;

const StyledCostDiv = styled.div`
  ${flexColumn}
  width: 100%;
  justify-content: flex-start;
  align-content: flex-start;
`;

const StyledStepsTitleContainer = styled.div`
  ${flexRow}
  width: 100%;
`;

const StyledIconContainer = styled.div`
  ${flexCenter}
  background-color: ${palette.interestGray};
  margin-top: 25px;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  ${breakpoints.tablet} {
    margin-top: 60px;
  }
`;

const SUPUESTOS_QAS = [
  {
    question: 'Supuestos generales',
    answer: (
      <Text type="body" color="white">
        Los cálculos aquí presentados suponen que el usuario comenzó a cotizar en el IMSS o el
        ISSSTE antes del 1 de julio de 1997. Es decir, que su pensión estará definida por la Ley del
        IMSS de 1973.
      </Text>
    ),
  },
  {
    question: 'Salario mínimo',
    answer: (
      <Text type="body" color="white">
        El salario mínimo general utilizado es de $123.22 diarios, establecido el 1 de enero de 2020
        (STPS).
      </Text>
    ),
  },
  {
    question: 'Unidad de Medida y Actualización (UMA)',
    answer: (
      <Text type="body" color="white">
        La UMA es la referencia económica en pesos para determinar la cuantía del pago de las
        obligaciones y supuestos previstos en las leyes federales. Se supone de $86.88 diarios,
        actualizado al 2020 (INEGI).
      </Text>
    ),
  },
  {
    question: 'Salario máximo de cotización',
    answer: (
      <Text type="body" color="white">
        El salario máximo de cotización se supone de 25 UMA vigentes.
      </Text>
    ),
  },
  {
    question: 'Salario de cotización',
    answer: (
      <Fragment>
        <Text type="body" color="white">
          En caso de que el usuario no conozca su salario base de cotización diario, se utiliza el
          salario después de impuestos reportado para realizar el cálculo. Es decir, se supone que
          la empresa en la que labora el usuario le dio alta ante el IMSS con el salario correcto de
          cotización. En ocasiones, las empresas dan indebidamente de alta a sus empleados con
          salarios de cotización menores al percibido. Si esto fuera el caso, implicaría que la
          pensión proyectada será mayor la real.
        </Text>
        <Text type="body" color="white">
          Igualmente, se supone que el salario base de cotización diario actual será el promedio de
          las últimas 250 semanas previo a la jubilación del usuario.
        </Text>
      </Fragment>
    ),
  },
];

const StyledFollowingCTA = css`
  width: 100vw;
  max-width: 250px;
  font-weight: 600;
  right: unset;
  margin-left: -125px;
  left: 50%;
  text-align: center;

  ${mq.md} {
    max-width: 350px;
    margin-left: -175px;
  }
`;

const StyledSecondaryCTA = css`
  width: 150px;
  color: red;
`;
const StickySection = styled.div`
  margin-bottom: 20px;
`;

const StyledDisclaimer = styled.div`
  border: 3px solid #f39292;
  border-radius: 8px;
  padding: 15px;
  margin-top: 30px;
  width: 100%;
  max-width: 450px;
`;

const ListContainer = styled.div`
  width: 100%;
  ${breakpoints.md} {
    max-width: 500px;
  }
`;

const List = styled.ul`
  padding-left: 0px;
  width: 100%;
`;
const contentPadding = `
padding: 20px;
${breakpoints.mobileLandscape} {
  padding: 20px 80px;
}
${breakpoints.tablet} {
  padding: 20px 120px;
}
${breakpoints.tabletLandscape} {
  padding: 20px 160px;
}
${breakpoints.desktop} {
  padding: 20px 350px;
}

`;
const Content = styled.div`
  ${flexColumn}
  justify-content: center;
  align-items: center;
  margin-top: ${HEADER_HEIGHT}px;
  ${contentPadding}
`;

const StyledFeature = styled.div`
  ${flexRow}
  justify-content: flex-start;
  align-items: center;
`;

const StyledSalesImage = styled.img`
  width: 100%;
  height: auto;
  margin-top: 20px;
  margin-right: 0px;
  margin-left: 0px;
  max-width: 100%;
  box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.3);
  ${breakpoints.mobileLandscape} {
    max-width: 500px;
  }
`;

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${palette.sweetGray};
  ${contentPadding}
`;

export const StyledDivision = styled.hr`
  display: block;
  width: 100%;
  height: 0px;
  margin-top: 30px;
  border-top: 1px solid ${palette.primaryColor}2b;
  border-bottom: none;
`;

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

class Results extends Component {
  state = {
    currentRetirementOption: -1,
    ctaButtonVisibility: '0',
  };

  componentWillMount() {
    const { match, retrieveRetirement } = this.props;
    if (match.params && match.params.uuid) {
      retrieveRetirement({ uuid: match.params.uuid });
      setTimeout(() => {
        this.setState({ timeoutDone: true });
      }, 2000);
    } else {
      this.setState({ timeoutDone: true, loading: false });
    }
  }

  componentDidMount = () => {
    scroll.scrollToTop();
    Mixpanel.only.mp('app/retiro/res/73');
    mp(`[${getCampaign(window.location.href)}] | Retiro | Resultado`);
    if (process.env.NODE_ENV === 'development') {
      this.setState({ currentRetirementOption: 1 });
    }
  };

  componentWillReceiveProps(nextProps) {
    const { currentRetirementOption } = this.state;
    if (nextProps.error && process.env.NODE_ENV !== 'development') {
      if (nextProps.result.error.response) {
        window.location.replace(`/error/${nextProps.result.error.response.status}`);
      } else {
        window.location.replace(`/error/511`);
      }
    } else if (currentRetirementOption === -1) {
      let number63Index =
        Object.keys(nextProps.retirement.data.pensionsLaw73).indexOf('63') !== -1
          ? Object.keys(nextProps.retirement.data.pensionsLaw73).indexOf('63')
          : 0;
      this.setState({ currentRetirementOption: number63Index });
    }
  }

  componentDidUpdate = () => {
    window.onbeforeunload = () => {
      mp(`[${getCampaign(window.location.href)}] | Retiro | Resultados | Se va`);
    };
  };

  getRetirementPercentage = (tasaDeRemplazo) => {
    let retirementPercentage = tasaDeRemplazo * 100;
    if (retirementPercentage > 100) retirementPercentage = 100;
    return retirementPercentage;
  };

  getSavingYears(userAge, maxSavingYears) {
    if (maxSavingYears - userAge > 5) {
      return 5;
    } else {
      return maxSavingYears - userAge;
    }
  }

  showPopUp = () => {
    mp('calculator/ir-a-clase');
    Swal.fire({
      title: 'Redirigiendote a la clase...',
      timer: 1500,
      timerProgressBar: true,
      onClose: () => {
        window.location = `https://www.finauta.com/webinar/reproducir?plan_id=${this.props.match.params.uuid}`;
      },
    });
  };

  render() {
    const { questions, currentRetirementOption, ctaButtonVisibility } = this.state;

    const { match, retirement, retrievingRetirement } = this.props;

    let ret;
    if (
      (process.env.REACT_APP_NODE_ENV === 'development' && !(match.params && match.params.uuid)) ||
      retrievingRetirement
    ) {
      ret = {
        data: {
          age: 62,
          uuid: 'f37ae4',
          monthlyWageAfterTaxes: 23000,
          grossSalary: 27641.462606,
          pensionsLaw73: {
            62: 18636.56788967661,
            63: 333.682930685143,
            64: 22543.00312076208,
            65: 24631.528459907448,
          },
          pensionsMod40: {
            62: 18636.56788967661,
            63: 25986.229801048114,
            64: 34484.663013419755,
            65: 44203.543816212994,
          },
        },
      };
    } else {
      ret = retirement;
    }

    const { pensionsLaw73, pensionsMod40 } = ret.data;

    let retirementOptions = Object.keys(pensionsLaw73);

    return (
      <Fragment>
        <FlowHeader>
          <a href="https://www.finauta.com">
            <WhiteLogo src={FinautaWhiteLogo} id="logo" />
          </a>
        </FlowHeader>
        <Content>
          <Title
            level={2}
            align="center"
            style={{
              lineHeight: 1,
              color: '#022759',
              marginBottom: '0px',
            }}
          >
            A tus
          </Title>
          <PlusMinus
            minusFunction={() => {
              if (retirementOptions[currentRetirementOption - 1]) {
                this.setState((state) => ({
                  currentRetirementOption: state.currentRetirementOption - 1,
                }));
              }
            }}
            plusFunction={() => {
              if (retirementOptions[currentRetirementOption + 1]) {
                this.setState((state) => ({
                  currentRetirementOption: state.currentRetirementOption + 1,
                }));
              }
            }}
            min={parseInt(retirementOptions[0])}
            max={parseInt(retirementOptions[retirementOptions.length - 1])}
            changingNumber={parseInt(retirementOptions[currentRetirementOption])}
            changingNumberColor={palette.terciaryColor}
          />
          <Title
            level={2}
            align="left"
            style={{
              lineHeight: 1.8,
              width: '100%',
              maxWidth: '470px',
              color: '#022759',
              marginTop: '0px',
            }}
          >
            Si sigues así, tu pensión máxima será de{' '}
            <NumberFormat
              style={{ color: '#08aeea' }}
              value={Math.round(pensionsLaw73[retirementOptions[currentRetirementOption]])}
              displayType="text"
              thousandSeparator
              prefix="$"
            />
            <span style={{ color: palette.terciaryColor, fontSize: '16px' }}>/mes</span>
          </Title>
          <StyledDivision />
          <Title
            level={2}
            align="left"
            style={{
              lineHeight: 1.8,
              width: '100%',
              maxWidth: '470px',
              color: '#022759',
            }}
          >
            Con nuestra asesoría, tu pensión podría ser de{' '}
            <NumberFormat
              style={{ color: '#08aeea' }}
              value={Math.round(pensionsMod40[retirementOptions[currentRetirementOption]])}
              displayType="text"
              thousandSeparator
              prefix="$"
            />
            <span style={{ color: palette.terciaryColor, fontSize: '16px' }}>/mes</span>
          </Title>
          <StyledDisclaimer>
            <Text type="body2" color="#FF7777" style={{ lineHeight: '1.4em' }}>
              <b>Ojo:</b> este es un aproximado basado en los datos proporcionados. Tu pensión puede
              variar.
            </Text>
          </StyledDisclaimer>
        </Content>
        <StyledSection>
          <Title
            level={3}
            color={palette.primaryColor}
            align="center"
            styles={css`
              margin-top: 20px;
              margin-bottom: 20px;
              max-width: 500px;
              ${breakpoints.tablet} {
                margin-bottom: 30px;
              }
            `}
          >
            Aprende a mejorar tu pensión con nuestra clase gratuita
          </Title>
          <StyledSalesImage src="https://finauta.s3.us-east-2.amazonaws.com/webinar/DSC_0017+(1)-min.JPG" />
          <Text
            styles={css`
              font-size: 14px;
              text-align: center;
              line-height: 1.2;
              margin-top: 10px;
              font-weight: 600;
              margin-bottom: 20px;
            `}
          >
            Javier Sinco – Co-Fundador de Finauta, Economista y Asesor Financiero
          </Text>
          <ListContainer>
            <Title level={5} color={palette.primaryColor} style={{ alignSelf: 'flex-start' }}>
              En esta clase exclusiva aprenderás:
            </Title>
            <List>
              {[
                'Cómo saber si te toca pensión',
                'De cuánto será tu pensión',
                'Cómo mejorar tu pensión',
              ].map((problem, index) => (
                <StyledFeature>
                  <Icon
                    icon="checkmarkWebinar"
                    style={{ width: '20px', alignSelf: 'flex-start', marginTop: '4px' }}
                    color={palette.secondaryColor}
                    size={20}
                  />
                  <Text
                    type="body2"
                    styles={css`
                      line-height: 1.4;
                      width: 90%;
                      margin-bottom: 20px;
                      margin-left: 10px;
                    `}
                  >
                    {problem}
                  </Text>
                </StyledFeature>
              ))}
            </List>
          </ListContainer>

          <Button
            full
            onClick={() => {
              this.showPopUp();
            }}
            style={{ marginBottom: '40px' }}
          >
            <Text
              styles={`
              font-weight: 600;
              font-size: 1.5em;
              ${breakpoints.tablet} {
                font-size: 2em;
              }
            `}
              color="white"
            >
              Ver clase GRATIS ahora
            </Text>
          </Button>
        </StyledSection>
        <StyledSection style={{ backgroundColor: palette.primaryColor }}>
          <Title
            level={3}
            color={palette.darkerGray}
            style={{ marginBottom: '20px', marginTop: '20px' }}
            color="white"
          >
            Preguntas frecuentes
          </Title>
          <Accordion
            accordion={true}
            style={{ width: '100%', marginTop: '10px', maxWidth: '750px' }}
          >
            {[
              {
                question: '¿Qué es Finauta?',
                answer: (
                  <Fragment>
                    <Text type="body1" color="white">
                      Finauta es una empresa mexicana que tiene como fin ayudarte a lograr tus metas
                      financieras. Por medio de herramientas financieras amigables y expertos
                      certificados, simplificamos las finanzas personales para que tú puedas lograr
                      tus sueños.{' '}
                    </Text>
                  </Fragment>
                ),
                hideTop: true,
              },
              {
                question: '¿Qué supuestos tomaron en cuenta?',
                expanded: true,
                answer: (
                  <Accordion
                    accordion={false}
                    style={{
                      marginLeft: '10%',
                      width: '90%',
                      marginTop: '10px',
                      maxWidth: '750px',
                    }}
                  >
                    {SUPUESTOS_QAS.map((question) => (
                      <FAQuestion
                        questionLevel={5}
                        event={question.metric}
                        question={question}
                        key={question.question}
                        expanded={question.expanded}
                        textColor="white"
                      />
                    ))}
                  </Accordion>
                ),
              },
            ].map((question) => (
              <FAQuestion
                questionLevel={5}
                event={question.metric}
                question={question}
                key={question.question}
                expanded={question.expanded}
                textColor="white"
              />
            ))}
          </Accordion>
          <Text
            styles={css`
              margin-top: 10px;
              width: 80vw;
              color: white;
              text-align: center;
            `}
          >
            Finauta {currentYear}
          </Text>
        </StyledSection>
      </Fragment>
    );
  }
}

Results.propTypes = {
  retirement: PropTypes.object,
  error: PropTypes.bool,
  retrieveRetirement: PropTypes.func,
  retrievingRetirement: PropTypes.bool,
  match: PropTypes.object,
};

Results.defaultProps = {
  retirement: {},
  error: false,
  retrievingRetirement: true,
  retrieveRetirement: () => {},
  match: {},
};

const mapStateToProps = (state) => ({
  retirement: state.retirement.retirement,
  result: state.retirement.result,
  retrievingRetirement: state.retirement.retrievingRetirement,
  error: state.retirement.error,
});

const mapDispatchToProps = (dispatch) =>
  bind(
    {
      retrieveRetirement: Retirement.Creators.retrieveRetirementRequested,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Results);
